import vxlColors from 'shared/styles/color/core';

const status = {
  positiveLight: vxlColors.core.primary.green[100],
  positiveLightHover: vxlColors.core.primary.green[200],
  positiveLightPressed: vxlColors.core.primary.green[300],
  positive: vxlColors.core.primary.green[500],
  positiveHover: vxlColors.core.primary.green[600],
  positivePressed: vxlColors.core.primary.green[700],
  positiveDark: vxlColors.core.primary.green[900],
  warningLight: vxlColors.core.primary.yellow[100],
  warningLightHover: vxlColors.core.primary.yellow[200],
  warningLightPressed: vxlColors.core.primary.yellow[300],
  warning: vxlColors.core.primary.yellow[500],
  warningHover: vxlColors.core.primary.yellow[600],
  warningPressed: vxlColors.core.primary.yellow[700],
  warningDark: vxlColors.core.primary.yellow[900],
  negativeLight: vxlColors.core.primary.red[100],
  negativeLightHover: vxlColors.core.primary.red[200],
  negativeLightPressed: vxlColors.core.primary.red[300],
  negative: vxlColors.core.primary.red[500],
  negativeHover: vxlColors.core.primary.red[600],
  negativePressed: vxlColors.core.primary.red[700],
  negativeDark: vxlColors.core.primary.red[900],
  infoLight: vxlColors.core.neutrals.grey[100],
  infoLightHover: vxlColors.core.neutrals.grey[200],
  infoLightPressed: vxlColors.core.neutrals.grey[300],
  info: vxlColors.core.neutrals.black,
  infoHover: vxlColors.core.neutrals.grey[600],
  infoPressed: vxlColors.core.neutrals.grey[400],
};

export default status;
